module.exports = __webpack_public_path__ + "media/images/countrysquared/tk-0c25269cd9d32136f85bbc6f44cd60f8.svg";